import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import ImportArticleFormContainer from "./forms/importFormContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useImportArticle() {
  const getCreateDialog = (onSubmitSuccess?: () => void): DialogProps => {
    return {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Article.ImportArticleRegister),
      titleIcon: IconDefinitionConstants.WBox,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Article.Import),
          successMessage: TranslationKeys.Article.ArticleImportSuccess,
        },
      ],
      dialogType: DialogEnums.DialogType.Content,
      children: <ImportArticleFormContainer />,
      maxWidth: "sm",
      onSubmit: onSubmitSuccess,
    };
  };

  return getCreateDialog;
}

export default useImportArticle;
